import gql from 'graphql-tag';

export const SAVE_APP_DATA_MUTATION = gql`
  mutation saveAppData($appApiKey: String, $trackingId: Int, $content: String) {
    appUserData {
      saveUserData(appApiKey: $appApiKey, trackingId: $trackingId, content: $content)
    }
  }
`;
